(function () {
  const slides = document.querySelectorAll('.hero__slide');
  const dots = document.querySelectorAll('.hero__dot');
  const prevBtn = document.querySelector('.hero__arrow--prev');
  const nextBtn = document.querySelector('.hero__arrow--next');
  const slidesTrack = document.querySelector('.hero__slides');

  if (!slides.length || !slidesTrack) return;

  let current = 0;
  const total = slides.length;
  let autoplayTimer = null;
  const spMediaQuery = window.matchMedia('(max-width: 1023px)');
  let dragStartX = 0;
  let dragStartY = 0;
  let dragDeltaX = 0;
  let isPointerDown = false;
  let isDragging = false;
  let activePointerId = null;
  let shouldSuppressClick = false;
  let suppressClickTimer = null;

  function goTo(index) {
    current = (index + total) % total;
    slidesTrack.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((dot, i) => {
      const isActive = i === current;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function startAutoplay() {
    stopAutoplay();
    if (total <= 1) return;
    autoplayTimer = setInterval(() => goTo(current + 1), 4000);
  }

  function stopAutoplay() {
    clearInterval(autoplayTimer);
  }

  function setDraggingTransform(deltaX) {
    slidesTrack.style.transition = 'none';
    slidesTrack.style.transform = `translateX(calc(-${current * 100}% + ${deltaX}px))`;
  }

  function resetDraggingTransform() {
    slidesTrack.style.transition = '';
    slidesTrack.style.transform = `translateX(-${current * 100}%)`;
  }

  function finishSwipe() {
    const trackWidth = slidesTrack.clientWidth || window.innerWidth;
    const swipeThreshold = Math.min(80, Math.max(40, trackWidth * 0.16));
    const shouldSlide = Math.abs(dragDeltaX) >= swipeThreshold;

    resetDraggingTransform();

    if (shouldSlide) {
      goTo(dragDeltaX < 0 ? current + 1 : current - 1);
    } else {
      goTo(current);
    }

    shouldSuppressClick = true;
    clearTimeout(suppressClickTimer);
    suppressClickTimer = window.setTimeout(() => {
      shouldSuppressClick = false;
    }, 250);
    startAutoplay();
  }

  function suppressClickAfterSwipe(event) {
    if (!shouldSuppressClick || !event.target.closest('.hero__link')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    shouldSuppressClick = false;
    clearTimeout(suppressClickTimer);
  }

  function resetPointerState() {
    isPointerDown = false;
    isDragging = false;
    activePointerId = null;
    dragStartX = 0;
    dragStartY = 0;
    dragDeltaX = 0;
  }

  function handlePointerDown(event) {
    if (!spMediaQuery.matches || total <= 1 || !event.isPrimary) return;

    isPointerDown = true;
    isDragging = false;
    activePointerId = event.pointerId;
    dragStartX = event.clientX;
    dragStartY = event.clientY;
    dragDeltaX = 0;
    stopAutoplay();

    if (slidesTrack.setPointerCapture) {
      slidesTrack.setPointerCapture(activePointerId);
    }
  }

  function handlePointerMove(event) {
    if (!isPointerDown || event.pointerId !== activePointerId) return;

    const deltaX = event.clientX - dragStartX;
    const deltaY = event.clientY - dragStartY;
    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

    if (!isDragging && Math.abs(deltaX) < 8) return;
    if (!isHorizontalSwipe) return;

    isDragging = true;
    dragDeltaX = deltaX;
    setDraggingTransform(deltaX);
  }

  function handlePointerUp(event) {
    if (!isPointerDown || event.pointerId !== activePointerId) return;

    if (slidesTrack.releasePointerCapture) {
      slidesTrack.releasePointerCapture(activePointerId);
    }

    if (isDragging) {
      finishSwipe();
    } else {
      startAutoplay();
    }

    resetPointerState();
  }

  function handlePointerCancel(event) {
    if (!isPointerDown || event.pointerId !== activePointerId) return;

    resetDraggingTransform();
    startAutoplay();
    resetPointerState();
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      stopAutoplay();
      goTo(current + 1);
      startAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      stopAutoplay();
      goTo(current - 1);
      startAutoplay();
    });
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', (event) => {
      event.preventDefault();
      stopAutoplay();
      goTo(i);
      startAutoplay();
    });
  });

  slidesTrack.addEventListener('pointerdown', handlePointerDown);
  slidesTrack.addEventListener('pointermove', handlePointerMove);
  slidesTrack.addEventListener('pointerup', handlePointerUp);
  slidesTrack.addEventListener('pointercancel', handlePointerCancel);
  slidesTrack.addEventListener('click', suppressClickAfterSwipe, true);
  slidesTrack.addEventListener('dragstart', (event) => event.preventDefault());

  goTo(0);
  startAutoplay();
})();
